import { AbstractSource } from "../../../../base/infrastructure/drawing";
import { IContentSource } from "../../../../base/domain/drawing";

export class EditableFormatTemporaryReferenceFileSource extends AbstractSource {
  constructor(getToken: () => string, public key: string) {
    super(getToken);
  }

  protected getSource(): string {
    const url = "/api/format-editor/temporary/reference/" + this.key + "?token=" + this.token;
    console.debug("[Source] " + url);
    return url;
  }

  public clone(): IContentSource {
    return new EditableFormatTemporaryReferenceFileSource(
      this._getToken,
      this.key
    );
  }
}
